/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import getChoiceIconStyle from "assets/getChoiceIconStyle";

const A_plus = ({ isActive = false }) => {
  const fill = getChoiceIconStyle(isActive);
  return (
    <svg
      width="80"
      height="80"
      viewBox="10 10 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="80" height="80" fill="none" />
      <path
        d="M35.684 61.696C35.3107 61.696 35.012 61.612 34.788 61.444C34.564 61.276 34.4333 61.052 34.396 60.772C34.3587 60.492 34.4147 60.1747 34.564 59.82L42.152 42.796C42.3387 42.348 42.572 42.0307 42.852 41.844C43.1507 41.6573 43.4773 41.564 43.832 41.564C44.168 41.564 44.476 41.6573 44.756 41.844C45.0547 42.0307 45.2973 42.348 45.484 42.796L53.072 59.82C53.24 60.1747 53.3053 60.5013 53.268 60.8C53.2307 61.08 53.1093 61.304 52.904 61.472C52.6987 61.6213 52.4093 61.696 52.036 61.696C51.6253 61.696 51.2987 61.5933 51.056 61.388C50.8133 61.1827 50.5987 60.8653 50.412 60.436L48.452 55.9L49.768 56.684H37.84L39.128 55.9L37.196 60.436C37.0093 60.884 36.804 61.2107 36.58 61.416C36.356 61.6027 36.0573 61.696 35.684 61.696ZM43.776 44.98L39.548 55.004L38.848 54.332H48.732L48.088 55.004L43.832 44.98H43.776ZM62.5172 60.576C62.1625 60.576 61.8919 60.4827 61.7052 60.296C61.5372 60.0907 61.4532 59.82 61.4532 59.484V54.5H56.5532C56.2172 54.5 55.9559 54.416 55.7692 54.248C55.5825 54.0613 55.4892 53.8 55.4892 53.464C55.4892 53.128 55.5825 52.876 55.7692 52.708C55.9559 52.5213 56.2172 52.428 56.5532 52.428H61.4532V47.584C61.4532 47.248 61.5372 46.9867 61.7052 46.8C61.8919 46.6133 62.1719 46.52 62.5452 46.52C62.8812 46.52 63.1332 46.6133 63.3012 46.8C63.4879 46.9867 63.5812 47.248 63.5812 47.584V52.428H68.4812C68.8359 52.428 69.0972 52.5213 69.2652 52.708C69.4519 52.876 69.5452 53.128 69.5452 53.464C69.5452 53.8 69.4519 54.0613 69.2652 54.248C69.0972 54.416 68.8359 54.5 68.4812 54.5H63.5812V59.484C63.5812 59.82 63.4879 60.0907 63.3012 60.296C63.1332 60.4827 62.8719 60.576 62.5172 60.576Z"
        fill={fill}
      />
    </svg>
  );
};

export default A_plus;
